import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TourInclude } from 'src/app/models';
import { EventBusService } from "../../../services/event-bus.service";
import {environment} from "../../../../environments/environment";
import {HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig} from "../../../config/hotel-tours-list-page.config";

@Component({
  selector: 'app-tour-include',
  templateUrl: environment.mobile ? './tour-include.component.mobile.html' : './tour-include.component.html',
  styleUrls: environment.mobile ? ['./tour-include.component.mobile.scss'] : ['./tour-include.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class TourIncludeComponent implements OnInit, OnDestroy {
  // Узкий вариант вывода, что включено
  @Input() isTight = false;

  isOnlyHotelsSearch = false;
  isShowFlight = false;
  isShowTransfer = false;
  isShowHotel = false;
  isShowMeal = false;
  isShowTourCode = false;
  isShowInsurance = false;

  messages: any = {};
  private onlyHotelsSearchSubscription: Subscription;

  constructor(
    @Inject(HOTEL_TOURS_PAGE_CONFIG) private hotelToursPageConfig: HotelToursPageConfig,
    private eventBusService: EventBusService,
    private cdRef: ChangeDetectorRef,) {
    this.messages = this.hotelToursPageConfig.translates.tourInclude;
  }

  ngOnInit() {
    this.isOnlyHotelsSearch = Boolean(this.hotelToursPageConfig.searchFormValues?.hotelsSearch);
    this.isShowFlight = this.hotelToursPageConfig.tourIncludes.indexOf(TourInclude.FLIGHT) !== -1;
    this.isShowTransfer = this.hotelToursPageConfig.tourIncludes.indexOf(TourInclude.TRANSFER) !== -1;
    this.isShowHotel = this.hotelToursPageConfig.tourIncludes.indexOf(TourInclude.HOTEL) !== -1;
    this.isShowInsurance = this.hotelToursPageConfig.tourIncludes.indexOf(TourInclude.INSURANCE) !== -1;

    this.onlyHotelsSearchSubscription = this.eventBusService.isOnlyHotelsSearch$
      .subscribe((isOnlyHotelsSearch:boolean) => {
        this.isOnlyHotelsSearch = isOnlyHotelsSearch;
        this.isShowFlight = !isOnlyHotelsSearch;
        this.isShowTransfer = !isOnlyHotelsSearch;

        this.cdRef.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this.onlyHotelsSearchSubscription?.unsubscribe();
  }
}
